import { reduxForm } from 'redux-form';
import { push } from 'react-router-redux/lib/actions';
// import validateTool from 'validate.js';
import { validateRedux, validateAsyncRedux } from '../../../utilites/validate'
import CompetitionsEditForm from './CompetitionsEditForm';
import { COMPETITIONS_ROUTER_ROOT } from '../constants'
import CRUDAction from '../../../actions/competition';
import Competition from '../../../api/competition';
import { convertDate } from './helper';
import config from 'config'

const validate = (data) => {
  return Object.assign(
    validateRedux(data, Competition.validateConstraints) || {}
  );
};

const asyncValidate = (data) => validateAsyncRedux(data, {
  image: {
    presence: {message: '^Please upload an image'},
    minImageSizeAsync: config.raffleCrop
  }
})

export default reduxForm(
  {
    form: 'competitions_edit_form',
    fields: [
      'name', 'image', 'number_of_winners', 'description', 'start_time', 'end_time', 'video'
    ],
    asyncBlurFields: ['image'],
    returnRejectedSubmitPromise: true,
    validate,
    asyncValidate
  },
  ( { competition : { model = null, loadingItem} } ) => ({
    model,
    loading: loadingItem,
    initialValues: Object.assign({}, model, model ? {
      start_time: convertDate(model.start_time),
      end_time: convertDate(model.end_time)
    } : {})
  }),
  dispatch => ({
    publish: (model) => dispatch(CRUDAction.publish(model)),
    save: (model, data) => dispatch(CRUDAction.save(model, data)),
    onClose: () => dispatch(CRUDAction.onCloseEditForm()),
    goIndex: () => dispatch(push(COMPETITIONS_ROUTER_ROOT))
  }),
)(CompetitionsEditForm)



// WEBPACK FOOTER //
// ./src/components/Competitions/CompetitionsEditForm/index.js